export const formatPercentage = (value, decimalPlaces = 0) => {
  if (value){
    let output = value.trim();
    let unstructuredValue = output.split('%');
    let num = parseFloat(unstructuredValue[0]);
    return `${num.toFixed(decimalPlaces)}%`;
  }
  return value;
};
